var publicPath = process.env.IS_PHYSICAL_MACHINE === 'true' ? '/kspay' : '/page/kspay-cashier-h5';
export { publicPath };